"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lighthouse_config_1 = require("../../../lighthouse.config");
exports.default = async (buffer, apiKey, mimeType = '') => {
    try {
        const token = 'Bearer ' + apiKey;
        const endpoint = lighthouse_config_1.lighthouseConfig.lighthouseNode + '/api/v0/add';
        // Upload file
        const blob = new Blob([buffer]);
        const formData = new FormData();
        formData.set('file', blob);
        const response = await fetch(endpoint, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: token,
                'Mime-Type': mimeType,
            },
        });
        if (!response.ok)
            throw new Error(`Request failed with status code ${response.status}`);
        const data = await response.json();
        return { data };
    }
    catch (error) {
        throw new Error(error?.message);
    }
};
